import PtIcon from '@patsnap-biz/icon';
import PtVirtualTree from '@patsnap-biz/virtual-tree';
import _ from 'lodash';
import '@patsnap-ui/icon/assets/solid/SmallDot.svg';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';
import '@patsnap-ui/icon/assets/solid/DropdownRight.svg';
import '@patsnap-ui/icon/assets/solid/SearchLeft.svg';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg';
import '@patsnap-ui/icon/assets/solid/CheckboxOn.svg';
import '@patsnap-ui/icon/assets/solid/CheckboxOff.svg';
import { NODE_HIGH_LIGHT_EXP } from '../utils';
export default {
    name: 'LabelLayerTree',
    components: {
        PtVirtualTree,
        PtIcon,
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        value: {
            type: Array,
            default: null,
        },
        field: {
            type: Object,
            default: () => ({}),
        },
        treeData: {
            type: Array,
            default: () => [],
        },
        filter: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            defaultExpandAll: true,
            defaultExpandKeys: [],
        };
    },
    computed: {
        checkedList: {
            get() {
                const selected = this.value || [];
                const lines = [];
                this.eachTreeItem(this.treeData, (node, line) => {
                    if (selected.indexOf(node.id) > -1) {
                        lines.push(..._.map(line, (i) => i.id));
                    }
                });
                return _.uniq(lines);
            },
            set(selected) {
                let nodes = [];
                // 只取叶子节点
                this.eachTreeItem(this.treeData, (node, line) => {
                    if (selected.indexOf(node.id) > -1) {
                        nodes.push(node.id);
                        _.forEach(line, (lineNode) => {
                            if (lineNode !== node) {
                                nodes = _.without(nodes, lineNode.id);
                            }
                        });
                    }
                });
                // 按勾选顺序排序
                nodes = _.sortBy(nodes, [
                    (id) => {
                        const index = _.indexOf(this.value, id);
                        return index === -1 ? Infinity : index;
                    },
                    (id) => _.indexOf(nodes, id),
                ]);
                this.$emit('change', nodes);
            },
        },
    },
    methods: {
        filterNodeMethod({ data }, filter) {
            const $filter = filter.toLowerCase();
            const $name = (data.name || '').toLowerCase();
            return $name.indexOf($filter) > -1;
        },
        getNodeName(name) {
            const $name = name || '';
            if (!this.filter)
                return $name;
            const $filter = (this.filter || '').toLowerCase().replace(NODE_HIGH_LIGHT_EXP, '\\$&');
            return $name.replace(new RegExp($filter, 'ig'), (i) => `<span class="custom-field-label-pane__layer-field-pane__item__highlight-node-name">${i}</span>`);
        },
        onCheckNode(node) {
            let checkedList = [...this.checkedList];
            const index = checkedList.indexOf(node.data.id);
            if (index > -1) {
                checkedList.splice(index, 1);
                // 如果取消节点，需要把子节点全部去掉
                if (node.data.children) {
                    const childrenNodes = [];
                    this.eachTreeItem(node.data.children, (i) => {
                        childrenNodes.push(i.id);
                    });
                    checkedList = _.filter(checkedList, (i) => childrenNodes.indexOf(i) === -1);
                }
            }
            else {
                checkedList.push(node.data.id);
            }
            this.checkedList = checkedList;
        },
        eachTreeItem(tree, cb, line = [], key = 'children') {
            // eslint-disable-next-line no-restricted-syntax
            for (const item of tree) {
                const $line = [...line];
                $line.push(item);
                cb(item, $line);
                if (item[key]) {
                    this.eachTreeItem(item[key], cb, $line, key);
                }
            }
        },
        onToggleNodeExpand(node, toggleNodeExpand) {
            toggleNodeExpand(node);
            this.$emit('toggleNodeExpand', node);
        },
    },
};
